/**
 * Возврат после входа в процесс единого входа (OpenID Connect).
 *
 * Приложение отправляет пользователя на /api/connect/authorize; если он не вошёл, ComradeMajor
 * перенаправляет сюда: /login?returnUrl=/api/connect/authorize?... После входа (cookie) нужно
 * вернуться на этот authorize-запрос — он выдаст приложению код.
 *
 * Переходить можно только туда: любой другой returnUrl — открытый редирект (ссылка «войти»,
 * после которой пользователя уводят на чужой сайт).
 */
const AUTHORIZE_PATH = "/api/connect/authorize";

const apiOrigin = (): string =>
  new URL(process.env.REACT_APP_API_URL || window.location.origin).origin;

/** Абсолютный адрес authorize-запроса или null, если returnUrl недопустим. */
export const resolveAuthorizeReturnUrl = (returnUrl: string | null): string | null => {
  // только относительный путь: не «//host», не «\host», не абсолютный URL
  if (!returnUrl || !returnUrl.startsWith("/") || returnUrl.startsWith("//") || returnUrl.includes("\\"))
    return null;

  try {
    const origin = apiOrigin();
    const target = new URL(returnUrl, origin);

    if (target.origin !== origin || target.pathname !== AUTHORIZE_PATH) return null;

    return target.toString();
  } catch {
    return null;
  }
};
